export default "/images/fe003161fe18b9737ed61be2f1718ed5.avif";